/*
Suresh Peddavoora 03/21/2023 3225736869 Added classname for add document dialogbox
Raghu 03/23/2023 3225736869 input field responsives
Akhila 04/18/2023 3225736869 rename client Number to client code and rearrange
Prakash 12/04/2023 2700708915 change checkbox color and fixed alignments issue in tab view.
Prakash 08/05/2023 2700708915 fixed alignments issues.
Sohel 05/09/2023 2700708915 Fixed Date Issue
Akhila 05/30/2023 2700708915 unsaved changes popup bug fixed
Ravi 06/14/2023 2700708915 rename Revone to RevOne
Akhila 06/14/2023 2700708915 bug fix unsaved changes on save button
Ravi 06/16/2023 2700708915 rename Company to companies
Ravi 06/22/2023 2700708915 fixed submit issue
Prakash 22/06/2023 2700708915 fixed alignments issues.
Sohel 12/07/2023 2700708915 Fixed Department Form Reset Issue
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  FormHelperText,
  Button,
  MenuItem,
  Grid,
  FormControl,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import {ThemeContext} from '../../themes/ThemeProvider';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../components/PageLoader';
import {
  fetchAllClientName,
  fetchServiceDataBasedOnCompany,
  fetchSiteDataBasedOnCorporate,
  getServiceClientDetails,
  postServiceClientInfo,
  resetToast,
} from '../../redux/reducers/clientMangement/Organizaation';
import {getFormattedDate} from '../../util/dateHelper';
import moment from 'moment';
import {submissionStart} from '../../redux/reducers/CommonActions/commonActions';
import {TENANTS_REVONE_COMPANIES} from '../../constants/ReusableConstants';
import GuiTextDateField from '../../components/FormComponents/GuiTextDateField';
import { Alert } from '@material-ui/lab';

const CompanyForm = ({
  setOpen = () => {},
  edit,
  tableData,
  siteTableData,
  handleDirty,
  organizationAccess,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [codePopover, setCodePopover] = useState(false);
  const [reportCodesData, setReportCodesData] = useState();
  const [clientCodeMsg, setClientCodeMsg] = useState(false);
  const renderRef = useRef(true);
  const dispatch = useDispatch();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    corporateAPIdata,
    companyAPIdata,
    isLoading,
    status,
    serviceClientInfo,
    successMsg,
    errorMsg,
    dropDownData,
    siteDataOnCorporate,
    serviceDataOnCompany,
    allClientNames,
    clientNumberAPIdata,
  } = useSelector(({organization}) => organization);

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  useEffect(() => {
    if (successMsg && serviceClientInfo?.clientId) {
      dispatch(getServiceClientDetails(serviceClientInfo?.clientId, 'Service-Client'));
    }
  }, [successMsg, serviceClientInfo?.clientId]);

  useEffect(() => {
    if (status === 200) {
      setOpen(false);
    }
  }, [status]);
  useEffect(() => {
    dispatch(fetchAllClientName());
  }, []);
  const seedOnlyOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const authorityOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const serviceClientData = (type) => {
    const clientData =
      tableData?.length > 0
        ? tableData.map((item) => {
          return item[type];
        })
        : editTableData?.length > 0
          ? editTableData.map((item) => {
            return item[type];
          })
          : [];
    return clientData;
  };

  const clientNameData = (data) => {
    const clientData =
      tableData?.length > 0 ? allClientNames : allClientNames?.length > 0 ? editTableData : [];
    return clientData;
  };

  const editTableData =
    allClientNames?.length > 0
      ? allClientNames?.filter(
        (el) =>
          el.clientName?.toLowerCase()?.trim() !==
            serviceClientInfo?.clientName?.toLowerCase()?.trim(),
      )
      : [];

  const checkClientDataExist = (value) => {
    if (clientNameData(allClientNames) && clientNameData(allClientNames)?.length > 0 && value) {
      const titleData = [];
      clientNameData(allClientNames)?.filter((i) => {
        if (
          i?.clientName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          titleData.push(i);
        }
      });
      return titleData.length > 0;
    } else {
      return false;
    }
  };
  const checkGroupCodeAlreadyExist = (value) => {
    if (clientNameData(allClientNames) && clientNameData(allClientNames)?.length > 0 && value) {
      const ar = [];
      clientNameData(allClientNames)?.filter((i) => {
        if (
          i?.clientName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const getCompanyCodesData = () => {
    if (serviceClientData('clientName') && serviceClientData('clientName')?.length > 0) {
      return serviceClientData('clientName')?.filter((i) =>
        i?.toLowerCase()?.trim().startsWith(reportCodesData?.toLowerCase()?.trim()),
      );
    } else {
      return [];
    }
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const maxWaitDate = new Date();
  maxWaitDate.setDate(maxWaitDate.getDate() + 30);
  const validationSchema = Yup.object().shape({
    clientName: Yup.string()
      .required('Client Name is required')
      .test(
        'clientName',
        'Client Name already exists',
        (value) => !checkClientDataExist(value, 'clientName'),
      )
      .test(
        'clientName',
        'Client Name has already been used in the past',
        (value) => !checkGroupCodeAlreadyExist(value),
      ),
    // clientClass: Yup.string().required("Client Class is required").nullable(),
    clientClass: Yup.mixed().test('clientClass', 'Client Class is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    companyName: Yup.mixed().test(
      'companyName',
      `${TENANTS_REVONE_COMPANIES} Name is required`,
      (value) => {
        if (!value?.companyId) {
          return false;
        } else {
          return true;
        }
      },
    ),
    corporateName: Yup.mixed().test('corporateName', 'Corporate Name is required', (value) => {
      if (!value?.corporateId) {
        return false;
      } else {
        return true;
      }
    }),
    serviceName: Yup.mixed().test('serviceName', 'Department Name is required', (value) => {
      if (!value?.serviceId) {
        return false;
      } else {
        return true;
      }
    }),
    siteName: Yup.mixed().test('siteName', 'Site Name is required', (value) => {
      if (!value?.siteName) {
        return false;
      } else {
        return true;
      }
    }),
    invoice: Yup.mixed().test('invoice', 'Invoice is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    invoiceType: Yup.mixed().test('invoiceType', 'Invoice Type is required', (value, valid) => {
      const value1 = valid?.parent;
      if (!value?.valueCode && value1?.invoice?.value === 'Yes') {
        return false;
      } else {
        return true;
      }
    }),
    // status: Yup.mixed().test("status", "Status is required", (value) => {
    //   if (!value?.value) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }),
    authorityToSue: Yup.mixed().test('authorityToSue', 'Authority to Sue is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    waitDate: Yup.date()
      .test('max Date', 'Wait date exceeded', (value) => {
        if (
          value &&
          value !== 'Invalid Date' &&
          new Date(maxWaitDate)?.setHours(0, 0, 0, 0) < new Date(value)?.setHours(0, 0, 0, 0)
        ) {
          return false;
        } else {
          return true;
        }
      })
      .test('min Date', 'Wait Date cannot be a previous Date', (value) => {
        const waitDateCondition =
          serviceClientInfo?.waitDate &&
          moment(serviceClientInfo.waitDate).format('MM/DD/YYYY') ===
            moment(value).format('MM/DD/YYYY');
        if (value && value !== 'Invalid Date' && waitDateCondition) {
          return true;
        } else if (
          value &&
          value !== 'Invalid Date' &&
          new Date(value)?.setHours(0, 0, 0, 0) < new Date()?.setHours(0, 0, 0, 0)
        ) {
          return false;
        } else {
          return true;
        }
      })
      .typeError('Invalid date format')
      .nullable(),
  });
  const getOption = (data, property, value) => {
    if (!data || data?.length === 0) {
      return {};
    }
    const obj = data?.find((item) => item[property] === value);
    return obj ? obj : {};
  };

  const initialVal = {
    clientClass: serviceClientInfo?.clientClass
      ? getOption(dropDownData?.CLIENT_CLASS, 'value', serviceClientInfo?.clientClass)
      : '',
    clientName: serviceClientInfo?.clientName || '',
    clientNumber: serviceClientInfo?.clientNumber || '',
    companyName: getOption(companyAPIdata, 'companyId', serviceClientInfo?.companyLevelId) || {},
    corporateName:
      getOption(corporateAPIdata, 'corporateId', serviceClientInfo?.corporateLevelId) || {},
    serviceName: getOption(serviceDataOnCompany, 'serviceId', serviceClientInfo?.serviceId) || {},
    siteName: getOption(siteDataOnCorporate, 'siteId', serviceClientInfo?.siteLevelId) || {},
    // status: getOption(StatusOptions, "value", serviceClientInfo?.status) || {},
    status: serviceClientInfo?.status === 'Active' ? true : false || (!serviceClientInfo && true),
    invoice: serviceClientInfo?.invoice
      ? getOption(seedOnlyOptions, 'value', serviceClientInfo?.invoice)
      : { key: 'Y', value: 'Yes' },
    authorityToSue: serviceClientInfo?.authorityToSue
      ? getOption(authorityOptions, 'value', serviceClientInfo?.authorityToSue)
      : { key: 'N', value: 'No' },
    invoiceType:
      getOption(dropDownData?.INVOICE_TYPE, 'value', serviceClientInfo?.invoiceType) || '',
    waitDate: serviceClientInfo?.waitDate
      ? moment(serviceClientInfo?.waitDate).format('MM/DD/YYYY')
      : '',
    clientId: serviceClientInfo?.clientId || '',
  };
  const [initialValues, setInitialvalues] = useState(initialVal);
  useEffect(() => {
    if (renderRef.current) {
      setInitialvalues({ ...initialVal });
    }
  }, [serviceClientInfo, serviceDataOnCompany, siteDataOnCorporate]);
  useEffect(() => {
    if (serviceClientInfo?.corporateLevelId) {
      dispatch(fetchSiteDataBasedOnCorporate(serviceClientInfo?.corporateLevelId));
      dispatch(fetchServiceDataBasedOnCompany(serviceClientInfo?.companyLevelId));
    }
  }, [serviceClientInfo?.corporateLevelId]);
  useEffect(() => {
    setInitialvalues({ ...initialVal });
  }, [serviceClientInfo]);

  const handleSubmit = (values) => {
    if (clientNumberAPIdata.includes(values?.clientNumber) && !serviceClientInfo?.clientNumber) {
      setClientCodeMsg(true);
    } else {
      setClientCodeMsg(false);
      dispatch(submissionStart());
      if (values) {
        const data = {
          clientClass: values?.clientClass?.value || '',
          clientId: serviceClientInfo?.clientId || 0,
          clientName: values?.clientName ? values?.clientName : '',
          clientNumber: values?.clientNumber ? values?.clientNumber : '',
          companyLevelId: values?.companyName?.companyId ? values.companyName?.companyId : 0,
          corporateLevelId: values?.corporateName?.corporateId
            ? values.corporateName?.corporateId
            : 0,
          serviceId: values?.serviceName?.serviceId ? values.serviceName?.serviceId : 0,
          siteLevelId: values?.siteName?.siteId ? values?.siteName?.siteId : 0,
          invoice: values?.invoice?.value ? values?.invoice?.value : '',
          invoiceType:
            values?.invoice?.value === 'Yes' && values?.invoiceType?.value
              ? values?.invoiceType?.value
              : '',
          // status: values?.status?.key ? values?.status?.key : "",
          status: values?.status ? 'Active' : 'Inactive',
          authorityToSue: values?.authorityToSue?.value ? values?.authorityToSue?.value : '',
          waitDate: values?.waitDate ? getFormattedDate(values?.waitDate) : '',
        };
        dispatch(postServiceClientInfo(data));
      }
      handleDirty(false, 'fixed');
    }
  };

  window.onclick = function () {
    setCodePopover(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            resetForm,
            dirty,
          } = props;
          if (dirty) {
            renderRef.current = false;
          }
          handleDirty && handleDirty(dirty);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className={`col-12`}>
                {clientCodeMsg ? (
                  <Alert severity="warning" className="mb-3">
                    Record exist with the same Corporate, Site and Department Name combination
                  </Alert>
                ) : null}
                <div className="form-row global-field-textfields  new-standard-textfields">
                  {serviceClientInfo?.clientNumber ? (
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={` ${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Client Code`}
                        label="Client Code"
                        disabled
                        name="clientNumber"
                        required
                        value={values.clientNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.clientNumber}
                        error={Boolean(touched.clientNumber && errors.clientNumber)}
                      />
                    </div>
                  ) : null}
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="companyName"
                      id="companyName"
                      size="small"
                      onBlur={handleBlur}
                      value={values.companyName}
                      options={companyAPIdata || []}
                      getOptionLabel={(option) => {
                        return option.companyName || '';
                      }}
                      disabled={serviceClientInfo?.companyLevelId}
                      onChange={(e, value) => {
                        value?.companyId &&
                          dispatch(fetchServiceDataBasedOnCompany(value?.companyId));
                        setFieldValue('serviceName', {});
                        setFieldValue('companyName', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            label={`${TENANTS_REVONE_COMPANIES} Name`}
                            placeholder={`Select ${TENANTS_REVONE_COMPANIES} Name`}
                            required
                            className={` ${classes.labelName}`}
                            touched={touched.companyName}
                            error={touched.companyName && errors.companyName}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.companyName && errors.companyName && errors.companyName}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="corporateName"
                      id="corporateName"
                      size="small"
                      onBlur={handleBlur}
                      value={values.corporateName}
                      options={corporateAPIdata || []}
                      getOptionLabel={(option) => {
                        return option.corporateName || '';
                      }}
                      disabled={serviceClientInfo?.corporateLevelId}
                      onChange={(e, value) => {
                        value?.corporateId &&
                          dispatch(fetchSiteDataBasedOnCorporate(value?.corporateId));
                        setFieldValue('siteName', '');
                        setFieldValue('corporateName', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            label="Corporate Name"
                            required
                            placeholder="Select Corporate Name"
                            className={` ${classes.labelName}`}
                            touched={touched.corporateName}
                            error={touched.corporateName && errors.corporateName}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.corporateName && errors.corporateName && errors.corporateName}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="serviceName"
                      id="serviceName"
                      size="small"
                      required
                      value={values.serviceName}
                      options={
                        values?.companyName?.companyName && serviceDataOnCompany?.length > 0
                          ? serviceDataOnCompany
                          : []
                      }
                      disabled={serviceClientInfo?.serviceId}
                      getOptionLabel={(option) => {
                        return option?.serviceName || '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('serviceName', value);
                        if (values?.siteName?.clientPrefix) {
                          setFieldValue(
                            'clientNumber',
                            values?.siteName?.clientPrefix + (value?.suffix ? value?.suffix : ''),
                          );
                        }
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Department Name"
                            placeholder="Select Department Name"
                            required
                            touched={touched.serviceName}
                            error={touched.serviceName && errors.serviceName}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.serviceName && errors.serviceName && errors.serviceName}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="siteName"
                      id="siteName"
                      size="small"
                      value={values.siteName}
                      options={
                        values?.corporateName?.corporateName && siteDataOnCorporate?.length > 0
                          ? siteDataOnCorporate
                          : []
                      }
                      disabled={serviceClientInfo?.siteLevelId}
                      getOptionLabel={(option) => option?.siteName || ''}
                      onChange={(e, value) => {
                        setFieldValue('siteName', value);
                        if (values?.serviceName?.suffix) {
                          setFieldValue(
                            'clientNumber',
                            (value?.clientPrefix || '') + values?.serviceName?.suffix,
                          );
                        }
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            label="Site Name"
                            placeholder="Select Site Name"
                            required
                            className={` ${classes.labelName}`}
                            touched={touched.siteName}
                            error={touched.siteName && errors.siteName}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.siteName && errors.siteName && errors.siteName}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <TextField
                      className={` ${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Client Name`}
                      label="Client Name"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      name="clientName"
                      required
                      value={values?.clientName}
                      onChange={(e) => {
                        setFieldValue('clientName', e.target.value);
                        if (e.target.value) {
                          setCodePopover(true);
                          setReportCodesData(e.target.value);
                        } else if (e.target.value === '') {
                          setCodePopover(false);
                        }
                      }}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.clientName}
                      error={Boolean(touched.clientName && errors.clientName)}
                    />
                    <FormHelperText>
                      {touched.clientName && errors?.clientName && errors.clientName}
                    </FormHelperText>
                    <div className="windowcode-popover Add-trigger-group-popover">
                      {codePopover &&
                        getCompanyCodesData()?.map((data, i) => (
                          <MenuItem key={i}>{data}</MenuItem>
                        ))}
                    </div>
                  </div>

                  <div className={`"col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group" `}>
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="clientClass"
                      id="clientClass"
                      size="small"
                      value={values.clientClass}
                      options={dropDownData?.CLIENT_CLASS || []}
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value
                          ? option.valueCode + ' - ' + option.value
                          : option.value === null
                            ? option.valueCode
                            : '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('clientClass', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            touched={touched.clientClass}
                            error={touched.clientClass && errors.clientClass}
                            margin="dense"
                            required
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            label="Client Class"
                            placeholder="Select Client Class"
                          />
                        </div>
                      )}
                    />
                    <FormHelperText style={{ color: 'red' }}>
                      {touched.clientClass && errors?.clientClass && errors.clientClass}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={`${{
                        popper: classes.popper,
                        option: classes.option,
                      }}`}
                      name="invoice"
                      id="invoice"
                      size="small"
                      options={seedOnlyOptions}
                      required
                      value={values.invoice}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('invoice', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Invoice"
                            placeholder="Select Invoice"
                            required
                            error={touched.invoice && errors.invoice}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.invoice && errors.invoice && errors.invoice}
                    </FormHelperText>
                  </div>
                  {values?.invoice?.value === 'Yes' && (
                    <div className="col-sm-8 col-md-4 col-lg-4 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="invoiceType"
                        id="invoiceType"
                        size="small"
                        options={dropDownData?.INVOICE_TYPE || []}
                        required
                        disabled={values?.invoice?.value === 'No'}
                        value={values.invoiceType}
                        getOptionLabel={(option) => {
                          return option?.value || '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('invoiceType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Invoice Type"
                              placeholder="Select Invoice Type"
                              required
                              error={touched.invoiceType && errors.invoiceType}
                            />
                          </div>
                        )}
                      />
                      <FormHelperText>
                        {touched.invoiceType && errors.invoiceType && errors.invoiceType}
                      </FormHelperText>
                    </div>
                  )}
                  <div className="col-sm-8 col-md-4 col-lg-4 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={`${{
                        popper: classes.popper,
                        option: classes.option,
                      }}`}
                      name="authorityToSue"
                      id="authorityToSue"
                      size="small"
                      options={authorityOptions}
                      required
                      value={values.authorityToSue}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('authorityToSue', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Authority to Sue"
                            placeholder="Select Authority to Sue"
                            required
                            error={touched.authorityToSue && errors.authorityToSue}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.authorityToSue && errors.authorityToSue && errors.authorityToSue}
                    </FormHelperText>
                  </div>

                  <Grid item xs={4} md={4} lg={4} xl={4} className={`form-group col-sm-3 `}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <GuiTextDateField
                        className={` ${classes.labelName} datefield`}
                        name={'waitDate'}
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        label={'Wait Date'}
                        fullWidth
                        value={values?.waitDate || null}
                        inputVariant="outlined"
                        helperText={''}
                        maxDate={maxWaitDate}
                        minDate={new Date()}
                        margin="dense"
                        touched={touched.waitDate}
                        error={touched.waitDate && errors.waitDate}
                        onChange={(date) => {
                          setFieldValue('waitDate', date);
                        }}
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        autoOk
                      />
                    </MuiPickersUtilsProvider>
                    <FormHelperText>{touched.waitDate && errors.waitDate}</FormHelperText>
                  </Grid>
                  <div className="col-sm-8 col-md-4 col-lg-4 col-xl-4 form-group">
                    <FormControl margin="dense">
                      <FormControlLabel
                        className={classes.checkRoot}
                        control={
                          <Checkbox onChange={handleChange} name="status" checked={values.status} />
                        }
                        label="Is Active"
                        labelPlacement="end"
                      />
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center new-standard-textfields mb-2">
                <Button
                  variant="outlined"
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    setClientCodeMsg(false)
                    resetForm();
                  }}
                >
                  Reset
                </Button>
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={(edit && !organizationAccess?.edit) || enabledSubmission}
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                >
                  Save
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
    </>
  );
};

export default CompanyForm;
